<script setup lang="ts">
interface Props {
  text?: string
}

const props = withDefaults(defineProps<Props>(), {
  text: undefined,
})

defineEmits<{
  click: []
}>()
</script>

<template>
  <button
    class="error-button text-[#D00045] font-semibold rounded-lg cursor-pointer"
    @click="$emit('click')"
  >
    <span class="error-button-wrap">
      <span class="error-button-text">
        <slot>{{ text }}</slot>
      </span>
      <span class="error-button-icon">
        <!-- Варіант 2: Подвійна стрілка -->
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M1 4v6h6M23 20v-6h-6"></path>
          <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
        </svg>
      </span>
      <span class="error-button-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M1 4v6h6M23 20v-6h-6"></path>
          <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
        </svg>
      </span>
    </span>
  </button>
</template>

<style scoped>
.error-button {
  outline: 1.5px solid #D00045;
  outline-offset: -2px;
  background: transparent;
  border: none;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  /* Паддинги з UIButton btn-large */
  padding: 18px 34px;
  font-size: 16px;
  font-family: var(--font-inter);
  font-weight: var(--font-weight-normal);
}

.error-button-wrap {
  display: inline-flex;
  align-items: center;
}

.error-button-text {
  margin-left: -13px;
  position: relative;
  z-index: 3;
  transition: transform 0.6s cubic-bezier(0.1, 0.75, 0.25, 1) 125ms;
}

.error-button:hover .error-button-text {
  transition-delay: 0.1s;
  transform: translateX(23px);
}

.error-button-icon {
  margin-left: 6px;
  position: relative;
  transition: opacity 0.4s cubic-bezier(0.1, 0.75, 0.25, 1) 0.25s, transform 0.6s cubic-bezier(0.1, 0.75, 0.25, 1) 0.25s;
  line-height: 0;
  z-index: 3;
  display: flex;
  align-items: center;
}

.error-button-icon svg {
  margin: 0;
  line-height: 0;
  display: block;
  flex-shrink: 0;
}

/* Друга іконка — прихована за замовчуванням, з'являється при hover */
.error-button-icon + .error-button-icon {
  order: -2;
  opacity: 0;
  transition-delay: 0s;
  margin-left: 0;
  transform: translateX(-10px);
}

.error-button:hover .error-button-icon {
  transition-delay: 0s;
  transform: translateX(10px);
  opacity: 0;
}

.error-button:hover .error-button-icon + .error-button-icon {
  opacity: 1;
  transform: translateX(0);
  transition-delay: 225ms;
}

.error-button:active {
  outline-width: 2px;
}
</style>
